import { useEffect, useState } from "react";
import { Loader2, Phone } from "lucide-react";
import { api } from "@/lib/api";

export default function AdminLeads() {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/admin/sell-leads").then((r) => setLeads(r.data)).catch(() => {}).finally(() => setLoading(false)); }, []);

  return (
    <div>
      <h1 className="font-display text-2xl font-extrabold text-slate-900">Sell Leads</h1>
      <p className="mt-1 text-slate-500">Machine sell requests submitted through the public form.</p>
      {loading ? <div className="flex justify-center py-16"><Loader2 className="h-6 w-6 animate-spin text-slate-400" /></div> : (
        <div className="mt-5 space-y-3">
          {leads.length === 0 && <p className="py-12 text-center text-slate-500">No sell leads yet.</p>}
          {leads.map((l) => (
            <div key={l.id} data-testid={`lead-row-${l.lead_code}`} className="rounded-xl border border-slate-200 bg-white p-4">
              <span className="font-mono text-xs text-slate-400">{l.lead_code}</span>
              <p className="font-semibold text-slate-900">{l.name}</p>
              <p className="inline-flex items-center gap-1 text-sm text-slate-500"><Phone size={12} /> {l.mobile}{l.whatsapp && ` • WA: ${l.whatsapp}`}</p>
              <p className="mt-1 text-sm text-slate-700"><span className="font-semibold">Machine:</span> {l.machine_name} {l.category && `(${l.category})`}</p>
              <p className="text-sm text-slate-500">{[l.city, l.state].filter(Boolean).join(", ")} {l.price && `• Approx: ${l.price}`}</p>
              {l.message && <p className="mt-1 rounded-lg bg-slate-50 p-2 text-sm text-slate-600">"{l.message}"</p>}
              <p className="mt-1 text-xs text-slate-400">{new Date(l.created_at).toLocaleString("en-IN")}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
